import styled from 'styled-components'

import LazyImage from '../../../components/display/LazyImage'

export const MobileListingSliderWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 0;
  padding-top: 75%;
  background-color: #333;

  transform: translate3d(0, 0, 0);

  ${LazyImage} {
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
  }
`
